import { render, staticRenderFns } from "./QuoteProductCollapsableItem.vue?vue&type=template&id=df0e8112&"
import script from "./QuoteProductCollapsableItem.vue?vue&type=script&lang=js&"
export * from "./QuoteProductCollapsableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports